/**
 * Tutorial Types — web port of client-native/src/features/tutorial/lib/types.ts.
 *
 * The 4-phase / 12-item onboarding checklist. Each item completes through an
 * action in the app (or a guided demo). iOS uses PNG icons with an emoji
 * fallback; the PWA renders the emoji directly (the component still supports a
 * future image url via `iconUrl`).
 */

import { TutorialItemID } from "@shared_types";

// Re-export the generated type for convenience.
export type TutorialItemId = TutorialItemID;

export interface TutorialItem {
  id: TutorialItemId;
  /** Optional image URL — falls back to `emoji` when absent. */
  iconUrl?: string;
  /** Fallback emoji (always present, used when no icon). */
  emoji: string;
  title: string;
  /** Key for backend integration / event tracking. */
  actionKey: string;
  /** When present, the item renders as an expandable accordion. */
  extraInfo?: string;
}

export interface TutorialPhase {
  id: string;
  phaseNumber: number;
  items: TutorialItem[];
}

export interface TutorialProgress {
  completedItems: TutorialItemId[];
  isDismissed: boolean;
  /** Local-only (mirrors iOS AsyncStorage; persisted to localStorage on web). */
  isCollapsed: boolean;
}

export const initialTutorialProgress: TutorialProgress = {
  completedItems: [],
  isDismissed: false,
  isCollapsed: false,
};
